import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';




export function getTipoMonedaListSuccess(tipomoneda) {
  return {type: types.LOAD_TIPOMONEDA_LIST_SUCCESS, tipomoneda};
}



export function getTipoMonedaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().TipoMonedaApi.getTipoMonedaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(tipomoneda => {                  
                  dispatch(getTipoMonedaListSuccess(tipomoneda));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getTipoMonedaSuccess(catalogo) {
  return {type: types.LOAD_TIPOMONEDA_SUCCESS, catalogo};
}

export function getTipoMoneda(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().TipoMonedaApi.getTipoMoneda(id, token).then(tipomoneda => {   
        dispatch(getTipoMonedaSuccess(tipomoneda));
        return tipomoneda;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(tipomoneda) {
  return {type: types.SAVE_TIPOMONEDA_SUCCESS, tipomoneda};
}


export function save(tipomoneda, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().TipoMonedaApi.save(tipomoneda, token).then(tipomonedaGuardado => {   
    dispatch(saveSuccess(tipomonedaGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getTipoMonedaComboSuccess(datos) {
  return {type: types.GET_TIPOMONEDAS_COMBO_SUCCESS, datos};
}

export function getTipoMonedaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().TipoMonedaApi.getTipoMonedaCombo(token).then(datos => {   
        
      dispatch(getTipoMonedaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(tipomoneda) {
  return {type: types.BORRAR_TIPOMONEDA_SUCCESS, tipomoneda};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().TipoMonedaApi.borrar(id, token ).then(tipomoneda => {
               
                  dispatch(borrarSuccess(tipomoneda));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(tipomoneda) {
  return {type: types.ACTIVAR_TIPOMONEDA_SUCCESS, tipomoneda};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().TipoMonedaApi.activar(id, token).then(tipomoneda => {
               
                  dispatch(activarSuccess(tipomoneda));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_TIPOMONEDA, filtro};
}



